module.exports = __webpack_public_path__ + "img/9788983947673.1a64abf6.jpg";